import { render, staticRenderFns } from "./ModalExtraTypeSectorComponent.vue?vue&type=template&id=92baf2b0&scoped=true"
import script from "./ModalExtraTypeSectorComponent.vue?vue&type=script&lang=js"
export * from "./ModalExtraTypeSectorComponent.vue?vue&type=script&lang=js"
import style0 from "./ModalExtraTypeSectorComponent.vue?vue&type=style&index=0&id=92baf2b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92baf2b0",
  null
  
)

export default component.exports